<div class="flex-row align-items-center">
  <a  class="logo" [routerLink]="['']">
    <img class="topbar-logo-img" [src]="getLogoPngUrl()">
    </a>
  @if (app.toolbarBackButton) {
    <span>
      <a class="icon" href="javascript:history.back()">
        <i class="fas fa-arrow-left"></i>
      </a>
    </span>
  }

  @if (app.breadcrumbsVisible && app.breadcrumbsInToolBar) {
    <p-breadcrumb class="breadcrumbs" [home]="app.breadcrumbsHome" [model]="app.breadcrumbsItems"></p-breadcrumb>
  }
  @if (app.staticHeaderHtml != null) {
    <div class="ml-5" [innerHTML]="app.staticHeaderHtml"></div>
  }
</div>
<div class="burger-menu mr-3 flex-row align-items-center primary-text-color">
  @if (app.multilingual) {
    <p-avatar class="primary-text-color ml-2 mr-3 mouse-pointer" size="normal" shape="circle" (click)="languageClicked()">
      <img src="{{_RestEndpoint.getUrl()}}/api/app/flag?language={{app.language}}">
    </p-avatar>
  }
  @if(app.toolbarShowUser) {
    <i class="fas fa-bars mouse-pointer" (click)="menuButtonClick(true)"></i>
  }
</div>
<div class="desktop-menu flex-row align-items-center">
  @if (app.toolbarHomeButton) {
    <a class="topbar-icon primary-text-color" href=# [routerLink]="['/enaio-learn', 'home']">
      <i class="fas fa-home"></i>
    </a>
  }
  @if (app.toolbarNotificationsButton) {
    <a class="topbar-icon primary-text-color" href="#" [routerLink]="['/enaio-learn', 'notifications']">
      <i class="fas fa-bell"></i>
      @if (app.unreadNotificationCount > 0) {
        <span class="topbar-badge">{{app.unreadNotificationCount}}</span>
      }
    </a>
  }
  @if (app.toolbarHelpButton) {
    <span class="topbar-icon topbar-round-icon primary-text-color mouse-pointer" (click)="helpClicked()">
      <i class="fas fa-circle-question"></i>
    </span>
  }
  @for (button of app.toolbarButtons; track button) {
    @if (button.visible) {
      <a class="topbar-icon primary-text-color" href="#" [routerLink]="button.routerLink" (click)="buttonClick(button)">
        <i [ngClass]="button.icon"></i>
      </a>
    }
  }
  @if (app.multilingual) {
    <p-avatar class="lang-icon topbar-round-icon primary-text-color mouse-pointer" size="normal" shape="circle" (click)="languageClicked()">
      <img src="{{_RestEndpoint.getUrl()}}/api/app/flag?language={{app.language}}">
    </p-avatar>
  }
  @if (app.toolbarShowUser) {
    <div class="user-menu mouse-pointer" (click)="menuButtonClick(false)">
      <p-avatar [label]="getUserNameShort()" class="user-avatar primary-text-color mr-3" size="large" shape="circle"></p-avatar>
      <span class="primary-text-color mr-3">{{getUserName()}}</span>
    </div>
  }
</div>
